export default __webpack_public_path__ + "static/loyall-featured-image-development-light-8f65396a881e75c9f20ba9cdbecf5a5f.jpg";